export function log(...messages) {
  if (process.env.environment != 'prod') {
    console.log(...messages);
  }
}
